const addresses = {
	title: "Adresser",
	stitle: "Adresse",
	new_address: "Ny adresse",
	edit_address: "Rediger",
	view_address: "Vis",
	list_title: "Adresseliste",
	list_subtitle: "Håndter adresser",
	create_title: "Opprett ny adresse",
	update_title: "Endre adresse",
	details_title: "Adresse detaljer",
	id: "ID",
	name: "Navn",
	street: "Gate",
	city: "Sted/By",
	state: "Fylke",
	zip: "Postnr",
	country: "Land",
	comments: "Kommentarer",
	status: "Status",
};
export default addresses;